export default "__VITE_ASSET__1nqL0nTj__"